<template>
  <div class="container">
    <div class="news">
      <div class="news-body">
        <div class="news-body-view">
          <div class="news-body-centent">
            <!-- 播聘新闻 -->
            <ul class="news-body-item-views">
              <li class="news-body-item-v" v-for="(s,i) in list" :key="i">
                <div class="news-body-item-content">
                  <div class="news-body-item-v-bg" :style="`background-image: url(${s.img});`"></div>
                  <div class="news-body-item-v-title">{{s.title}}</div>
                  <div class="news-body-item-v-sub">
                    <div class="news-body-item-v-sub-from">来源：{{s.froms}}</div>
                    <div>时间：{{s.date}}</div>
                  </div>
                  <div class="news-body-item-v-content">{{s.content}}</div>
                  <div class="news-body-item-v-more" @click="navgoTo(s)">阅读全文></div>
                </div>
              </li>
            </ul>
      </div>
    </div>
   </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "recruitment-skills",
  data() {
    return {
             //播聘新闻
      list: [
        {
          title: "如何招到合适的人才",
          froms: "来源:播聘 | ",
          date: "2019年9月24日 | 招聘技巧",
          img: "../../../static/Recruitment skills.jpg",
          content:
            "在企业选聘新员工时，自己找上门或看到报纸、网络的招聘广告后打电话应聘的这二类候选人中，一般情况下是缺乏优秀人才的。最佳的人才往往都已拥有一份工作，甚至还没有必要去寻求新的职位。企业惟有花一些时间和高等院校的就业指导中心、专业人才服务机构建立良好的关系，并鼓励内部员工积极参与行业内的专业组织与活动，惟此，才有可能成功地寻找到优秀的人才。因为，这二个方式大大改善了企业的人才库，使企业甄选人才的范围得以扩大。此外，经常浏览人才网站，将一些合适的人才简历收入企业的人才库中;注意在一些专业的网站与刊物上发布招聘广告也会有所帮助。这些做法的关键是在企业需要一个优秀的人才库之前就先建立好它。",
          path: "/recruitment-skills_to"
        },
      ],
    }
  },
       methods: {
          navgoTo(s) {
      this.$nav({ path: s.path }, this);
    }
     }
};
</script>

<style scoped="scoped">
@import url("./recruitment-skills.css");
</style>



// WEBPACK FOOTER //
// src/pages/recruitment-skills/recruitment-skills.vue